// Chrome's auto-translate (and similar extensions) rewrite the DOM behind
// React's back — text nodes get wrapped in <font> tags — so React's next
// commit can call removeChild/insertBefore with nodes that are no longer
// where it left them, throwing NotFoundError and unmounting the whole tree
// (Sentry MEMBRZ-WEB-5). Known React 17 limitation, see
// https://github.com/facebook/react/issues/11538#issuecomment-417504600 —
// degrade these calls to no-ops instead of crashing.
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (console) {
        console.warn('Cannot remove a child from a different parent', child, this);
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (console) {
        console.warn('Cannot insert before a reference node from a different parent', referenceNode, this);
      }
      return this.appendChild(newNode);
    }
    return originalInsertBefore.apply(this, arguments);
  };
}
